const formEquipmentsLogs = {
  actionsNotFound: 'No se encontró ningún registro'
};

export default formEquipmentsLogs;
